import { React, useState,useEffect } from "react";
import axios from 'axios'
import {LINKDATASHARING} from '../AppConstant'
import image from  "./img/switch.png";
import "./index.css";
import { Button} from "@mui/material";

function Landing() {
    
   
    const [empid,setEmpid]=useState("")
     useEffect(()=>{callrejectfn()},[])

    const callrejectfn=()=>{
        let urls;
        let vals;
        let finaldata;
        urls= window.location.href
        vals = urls.split("?")
        let data = vals[1];
        finaldata = data.split(",");
        console.log(finaldata[0],finaldata[1])
        setEmpid(data)

    }
    
    const rejectfn = ()=>{
        var link = document.getElementById("texcomm").value;
        axios.post(LINKDATASHARING, {empid,link})
        .then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data.data);
          console.log(response.data)
        
          

        })
          .catch(function (error) {
            console.log(error);
          });
       
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }

   
    return (
        <div className="bg_set_reject">   
        <div className="switch" >
              
                   <img className="switch-img" src={image}/>
                   
               </div>
            <div className="logo">        
            
            </div>
            <div className="bty-cont">
            <div className="success-container">        

            <div className="success-icon">
                
           
            <label for="w3review">Paste Link</label>
            <div className="success-message">
            
        
        <textarea id="texcomm" name="texcomm" rows="4" cols="50">
        
        </textarea>
            </div>
            <Button className="button-design"  onClick={() => {rejectfn()}}>
              Submit
            </Button>
        {/* <a href="/" className="back-button">Submit</a> */}
        </div>
        </div>
        </div>
        </div>
    );
}


export default Landing;
